import styled from 'styled-components';

import {
  Box,
  getRadii,
  ModalBody,
  ModalClose,
  ModalDialog,
  Spacer,
  Typography,
  ThemeProvider,
} from '@aircall/tractor-v2';
import { dashboardThemeV2 } from '@config/theme/theme';
import { Loading } from '@dashboard/library';

import { ModalStatusProps } from '.';

const ImageWrapper = styled(Box)`
  display: flex;
  width: 280px;
  height: 160px;
  align-items: center;
  justify-content: center;
  border-radius: ${getRadii('default')};
`;

const TextWrapper = styled(Spacer)`
  max-width: 450px;
  text-align: center;
`;

export function ModalStatus({
  isModalOpen,
  onModalHide,
  body,
  title,
  image,
  imageBackgroundColor,
  loadingState,
}: ModalStatusProps) {
  return (
    <ThemeProvider theme={dashboardThemeV2}>
      <ModalDialog
        show={isModalOpen}
        onHide={onModalHide}
        size='xSmall'
        rootClose={!loadingState}
        portalContainer={document && document.getElementById('portal-root')!}
      >
        {!loadingState && <ModalClose />}
        <ModalBody p='xl' pt={loadingState ? '' : 'unset'}>
          <Spacer direction='vertical' justifyContent='center' alignItems='center' space='l' fluid>
            <ImageWrapper backgroundColor={imageBackgroundColor}>{image}</ImageWrapper>
            <TextWrapper direction='vertical' space='xxs'>
              <Typography variant='headingBoldXS'>{title}</Typography>
              <Typography variant='bodyRegularM' whiteSpace='pre-line'>
                {body}
              </Typography>
            </TextWrapper>
            {loadingState && (
              <ThemeProvider>
                <Loading data-test='modal-status-loading' />
              </ThemeProvider>
            )}
          </Spacer>
        </ModalBody>
      </ModalDialog>
    </ThemeProvider>
  );
}
